import { render, staticRenderFns } from "./AddToMyBucketButton.vue?vue&type=template&id=64c66e84&"
import script from "./AddToMyBucketButton.vue?vue&type=script&lang=js&"
export * from "./AddToMyBucketButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports